<template>
  <tr v-if="showField" class="tr-response">
    <td class="td-left">
      <div class="div-left">
        <div class="col-title">{{ title }}</div>
        <div
          v-if="required"
          class="col-require text-right"
        >
          {{ $t('register-page.status.required', {split: '/'}) }}
        </div>
      </div>
    </td>
    <td class="td-right">
      <div class="div-right">
        <slot></slot>
      </div>
      <div
        v-if="inputExample && inputExamples.length !== 0"
        class="input-example-style"
      >
        {{
          this.$i18n.locale !== 'vn'
            ? inputExamples[inputExample].input_example
            : inputExamples[inputExample].input_example_vn
        }}
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'FormField',
  props: {
    title: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    showField: {
      type: Boolean,
      default: true
    },
    inputExample: {
      type: Number,
      default: null
    },
    inputExamples: {
      type: Array,
      default: () => []
    }
  }
};
</script>
